import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import instantExchange from '../views/instantExchange.vue'
import deferredExchange from '../views/deferredExchange.vue'
import faq from '../views/faq.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'Home',
    component: Home
  },
  {
    path: '/instantExchange',
    name: 'instantExchange',
    component: instantExchange
  },
  {
    path: '/deferredExchange',
    name: 'deferredExchange',
    component: deferredExchange
  },
  {
    path: '/faq',
    name: 'faq',
    component: faq
  }
]

const router = new VueRouter({
  // mode: 'history',
  // base: process.env.BASE_URL,
  routes
})
// 解决编程式路由往同一地址跳转时会报错的情况
const originalPush = VueRouter.prototype.push
const originalReplace = VueRouter.prototype.replace
// push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject)
  } else {
    return originalPush.call(this, location).catch(err => err)
  }
}
// replace
VueRouter.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalReplace.call(this, location, onResolve, onReject)
  } else {
    return originalReplace.call(this, location).catch(err => err)
  }
}

export default router
